import * as _ from "lodash";
import React, { useMemo, useState } from "react";
import { Checkbox } from "@material-ui/core";

import "./SupplierAgentsDetails.scss";
import { Mode } from "../../../../../shared/constants";
import { useTranslation } from "react-i18next";
import YeulsTabs from "../../../../yeuls-tabs";
import AccountsSearchField from "../../../common-components/accounts-search-field";
import YeulsTable from "../../../../yeuls-table";

const tabIds = {
  agentsList: 0,
  companiesList: 1
}
const SupplierAgentsDetails = (props) => {
  const {
    mode,
    users,
    companies,
    supplier,
    onSupplierAgentChange,
    supplierUserAgentsChanges,
    supplierCompanyAgentsChanges
  } = props;
  const { i18n, t } = useTranslation();
  const [filterValue, setFilterValue] = useState("");
  const [currentTabId, setCurrentTabId] = useState(tabIds.agentsList);
  const [updateTable, setUpdateTable] = useState(true);
  const userHeaders = useMemo(() => mode === Mode.edit ?
    [".", t("name"), t("client-number"), t("business-number")] :
    [t("name"), t("client-number"), t("business-number")], [i18n.language, mode]);
  const userColumns = useMemo(() =>
      mode === Mode.edit ?
        "selectedView.nameView.santec_account_id.business_number" :
        "nameView.santec_account_id.business_number"
    , [mode]);
  const companyHeaders = useMemo(() => mode === Mode.edit ?
    [".", t("company-name"), t("client-number"), t("business-number")] :
    [t("company-name"), t("client-number"), t("business-number")], [i18n.language, mode]);
  const companyColumns = useMemo(() =>
      mode === Mode.edit ?
        "selectedView.company_name.santec_account_id.business_number" :
        "company_name.santec_account_id.business_number"
    , [mode]);
  const tabsConfig = useMemo(() => [
    {
      id: tabIds.agentsList,
      label: "agents-list",
      defaultSelectedTab: currentTabId === tabIds.agentsList,
      itemsCount: _.filter(supplier.supplierAgents, (sa) => !!sa.user_id)?.length
    }, {
      id: tabIds.companiesList,
      label: "companies-list",
      itemsCount: _.filter(supplier.supplierAgents, (sa) => !!sa.company_id)?.length
      // eslint-disable-next-line
    }], [i18n.language, supplier]);

  const filteredUsers = useMemo(() => {
    const filterValueToLowerCase = filterValue?.toLowerCase();
    const supplierUserIds = _.map(supplier.supplierAgents, "user_id").filter(Boolean);
    const filteredValues = _.filter(users, (user) =>
      ( user.firstname?.toLowerCase() || "" ).indexOf(filterValueToLowerCase) !== -1 ||
      ( user.email?.toString() || "" ).indexOf(filterValueToLowerCase) !== -1);

    return [
      ..._.filter(filteredValues, (value) => _.includes(supplierUserIds, value.id)),
      ..._.filter(filteredValues, (value) => !_.includes(supplierUserIds, value.id)),
    ]
    // eslint-disable-next-line
  }, [filterValue, mode, users]);

  const mappedUsers = useMemo(() => {
    const supplierUserIds = _.map(supplier.supplierAgents, "user_id").filter(Boolean);

    if (!_.values(supplierUserAgentsChanges)?.length) {
      setUpdateTable(false);
      setTimeout(() => setUpdateTable(true));
    }

    return _(filteredUsers)
      .filter((user) => mode === Mode.edit || _.includes(supplierUserIds, user.id))
      .map((user) => {
        let nameView = user.firstname;
        if (user.lastname)
          nameView += ` ${user.lastname}`

        return {
          ...user,
          nameView,
          selectedView: <Checkbox checked={( !!_.find(supplier.supplierAgents, { user_id: user.id }) ||
            !!supplierUserAgentsChanges[user.id] ) && !supplierUserAgentsChanges[user.id]?.delete}
                                  onChange={(e) => onAgentChange(e, { user })}/>,
        }
      })
      .value();
  }, [filteredUsers, mode, supplierUserAgentsChanges]);

  const filteredCompanies = useMemo(() => {
    const filterValueToLowerCase = filterValue?.toLowerCase();
    const supplierCompanyIds = _.map(supplier.supplierAgents, "company_id").filter(Boolean);
    const filteredValues = _.filter(companies, (company) =>
      ( company.company_name?.toLowerCase() || "" ).indexOf(filterValueToLowerCase) !== -1 ||
      ( company.email?.toString() || "" ).indexOf(filterValueToLowerCase) !== -1);

    return [
      ..._.filter(filteredValues, (value) => _.includes(supplierCompanyIds, value.id)),
      ..._.filter(filteredValues, (value) => !_.includes(supplierCompanyIds, value.id)),
    ]
    // eslint-disable-next-line
  }, [filterValue, mode, companies]);

  const mappedCompanies = useMemo(() => {
    const supplierCompanyIds = _.map(supplier.supplierAgents, "company_id").filter(Boolean);

    if (!_.values(supplierCompanyAgentsChanges)?.length) {
      setUpdateTable(false);
      setTimeout(() => setUpdateTable(true));
    }

    return _(filteredCompanies)
      .filter((company) => mode === Mode.edit || _.includes(supplierCompanyIds, company.id))
      .map((company) => {
        return {
          ...company,
          selectedView: <Checkbox checked={( !!_.find(supplier.supplierAgents, { company_id: company.id }) ||
            !!supplierCompanyAgentsChanges[company.id] ) && !supplierCompanyAgentsChanges[company.id]?.delete}
                                  onChange={(e) => onAgentChange(e, { company })}/>,
        }
      })
      .value();
  }, [filteredCompanies, mode, supplierCompanyAgentsChanges]);

  const onAgentChange = (e, { user, company }) => {
    if (!e.target.checked && user)
      onSupplierAgentChange({ userId: user.id }, {
        ..._.find(supplier.supplierAgents, { user_id: user.id }),
        delete: true
      } || null);

    if (e.target.checked && user)
      onSupplierAgentChange({ userId: user.id }, _.find(supplier.supplierAgents, { user_id: user.id }) || {
        user_id: user.id,
        supplier_id: supplier.id
      });

    if (!e.target.checked && company)
      onSupplierAgentChange({ companyId: company.id }, {
        ..._.find(supplier.supplierAgents, { company_id: company.id }),
        delete: true
      } || null);

    if (e.target.checked && company)
      onSupplierAgentChange({ companyId: company.id }, _.find(supplier.supplierAgents, { company_id: company.id }) || {
        company_id: company.id,
        supplier_id: supplier.id
      });
  }

  return <div className="supplier-agents-details-wrapper">
    <YeulsTabs
      config={tabsConfig}
      onChange={(value) => {
        setFilterValue("");
        setCurrentTabId(value)
      }}/>
    {currentTabId === tabIds.agentsList && <>
      {mode === Mode.edit &&
      <AccountsSearchField filterValue={filterValue} setFilterValue={setFilterValue} showSearchMessage={false}/>}
      {updateTable && <YeulsTable
        data={mappedUsers}
        headers={userHeaders}
        columns={userColumns}
        totalCount={mappedUsers.length}
        perPageItemCount={12}
        partialPageCount={3}
        nextPageText=">"
        prePageText="<"
        className={`agents-table-container ${mode === Mode.edit ? "edit" : "view"}`}
      />}

      {mode === Mode.view && !_.find(supplier.supplierAgents, (agent) => agent.user_id) &&
      <div className="empty-list">{t("supplier-users-empty-list")}</div>}
    </>}
    {currentTabId === tabIds.companiesList && <>
      {mode === Mode.edit &&
      <AccountsSearchField filterValue={filterValue} setFilterValue={setFilterValue} showSearchMessage={false}/>}
      {updateTable && <YeulsTable
        data={mappedCompanies}
        headers={companyHeaders}
        columns={companyColumns}
        totalCount={mappedCompanies.length}
        perPageItemCount={12}
        partialPageCount={3}
        nextPageText=">"
        prePageText="<"
        className={`agents-table-container ${mode === Mode.edit ? "edit" : "view"}`}
      />}
      {mode === Mode.view && !_.find(supplier.supplierAgents, (agent) => agent.company_id) &&
      <div className="empty-list">{t("supplier-companies-empty-list")}</div>}
    </>}
  </div>
}

export default SupplierAgentsDetails;
